<div class="container-fluid mt-4">
  <form class="form-horizontal" (ngSubmit)="submit()">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <h3>Journey</h3>
          </div>
          <div class="card-body">
            <div *ngIf="!journey">Loading...</div>

            <ng-container *ngIf="journey">
              <!-- Name -->
              <h4 class="mt-3">Name</h4>
              <div class="row my-2">
                <div class="form-group">
                  <input
                    name="name"
                    class="form-control"
                    autofocus="true"
                    type="text"
                    [ngModel]="journey.name"
                    [placeholder]="journey.name"
                    (ngModelChange)="journey.name = $event.trim(); changed = true;"
                    required
                  />
                </div>
              </div>

              <!-- Paths -->
              <h4 class="mt-3">Paths</h4>
              <label class="small">
                Select nodes the user should work on. A path element is considered completed if the user opened a related wiki article.
              </label>
              <ul class="list-group">
                <li class="list-group-item" *ngFor="let child of journey.children; let index = index">
                  <span
                    *ngIf="!child.node"
                    class="text-danger"
                    ngbTooltip="The node assigned to this journey has been deleted or is not translated for the currently selected language"
                  >
                    Node missing
                  </span>
                  <app-nested-path-selector
                    [tree]="tree"
                    [element]="child"
                    [maxDepth]="maxDepth"
                    [readonly]="loading"
                    (elementChange)="onElementChange(index, $event)"
                  >
                  </app-nested-path-selector>
                </li>
                <li class="list-group-item">
                  <div class="row my-2">
                    <div style="width: auto">
                      <button class="btn btn-primary" type="button" [disabled]="loading" (click)="addPath()">
                        <fa-icon [icon]="['fal', 'plus']"></fa-icon>
                        Add Path
                      </button>
                    </div>
                  </div>
                </li>
              </ul>

              <!-- Selectors (Filters) -->
              <h4 class="mt-3">User/Group Filter</h4>
              <ng-container *ngIf="labels && labels.length == 0">
                <label class="small">
                  Filters determine which users should have access to this journey. Without filters everyone will see it.<br />
                  The filter operates on labels which have to be added to users in the users tab first.
                </label>
              </ng-container>
              <ng-container *ngIf="labels?.length > 0">
                <label class="small">
                  Filters determine which users should have access to this journey. Without filters everyone will see it.<br />
                  The filter operates on labels which can be added to users tab.
                </label>
                <ul class="list-group">
                  <li class="list-group-item" *ngFor="let filter of journey.filters; let index = index">
                    <div class="row">
                      <div class="col">
                        <select class="form-select" [(ngModel)]="filter.key" [name]="'filter-key-' + index" (change)="filter.value = ''">
                          <option *ngFor="let l of labels" [value]="l.key">{{ l.key }}</option>
                        </select>
                      </div>
                      <div class="col-auto px-0">
                        <button
                          class="btn"
                          [ngClass]="filter.positive ? 'btn-light' : 'btn-secondary'"
                          type="button"
                          (click)="filter.positive = !filter.positive; changed = true;"
                        >
                          {{ filter.positive ? '=' : '&ne;'}}
                        </button>
                      </div>
                      <div class="col">
                        <select class="form-select" [(ngModel)]="filter.value" [name]="'filter-value-' + index">
                          <option *ngFor="let v of labelOptions[filter.key]" [value]="v">{{ v }}</option>
                        </select>
                      </div>
                      <div class="col-auto ps-0">
                        <button class="btn btn-danger" type="button" (click)="journey.filters.splice(index, 1); changed = true;">
                          <fa-icon [icon]="['fal', 'times']"></fa-icon>
                        </button>
                      </div>
                    </div>
                  </li>

                  <li class="list-group-item">
                    <div class="row my-2">
                      <div style="width: auto">
                        <button class="btn btn-primary" type="button" [disabled]="loading" (click)="addFilter()">
                          <fa-icon [icon]="['fal', 'plus']"></fa-icon>
                          Add Filter
                        </button>
                      </div>
                    </div>
                  </li>
                </ul>
              </ng-container>

              <!-- Errors -->
              <div *ngIf="error" class="mb-2 mt-4" style="text-align: right">
                <label class="small text-danger">{{ error }}</label>
              </div>

              <!-- Buttons -->
              <div class="btn-group float-end my-2">
                <button class="btn btn-light" type="button" [disabled]="loading" (click)="cancel()">
                  <fa-icon icon="times-circle" size="md"></fa-icon>
                  Cancel
                </button>
                <button [disabled]="error" type="submit" class="btn btn-primary" [disabled]="loading || error || !changed">
                  <fa-icon icon="sync-alt" size="md"></fa-icon>
                  {{ journey.uuid == null ? 'Create' : 'Update' }}
                </button>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
